// Values that differ per environment and never per brand, so the published config does not carry
// them (decision 2026-10-02, Specs > Config schemas). POS imports this, so it imports nothing.
export type PlatformEnvironment = 'dev' | 'prod'

export interface PlatformValues {
  mqttUri: string
  mqttClientId: string
  mqttUsername: string
  mqttPassword: string
}

export const PLATFORM_VALUES: Record<PlatformEnvironment, PlatformValues> = {
  dev: {
    mqttUri: 'wss://emqx.dev.t-soft.io/mqtt',
    mqttClientId: 'mts',
    mqttUsername: 'ui',
    mqttPassword: 'Gj0wJwVoWosVsSM'
  },
  prod: {
    mqttUri: 'wss://emqx.prod.t-soft.io/mqtt',
    mqttClientId: 'mts',
    mqttUsername: 'ui',
    mqttPassword: 'HqA612Dqh3Fe'
  }
}

export interface MqttConfig {
  MQTT_URI: string
  MQTT_CLIENTID: string
  MQTT_USERNAME: string
  MQTT_PASSWORD: string
}

// The broker settings under the keys retail's and POS's configs use.
export const mqttConfig = (environment: PlatformEnvironment): MqttConfig => {
  const values = PLATFORM_VALUES[environment]
  return {
    MQTT_URI: values.mqttUri,
    MQTT_CLIENTID: values.mqttClientId,
    MQTT_USERNAME: values.mqttUsername,
    MQTT_PASSWORD: values.mqttPassword
  }
}

export const isLocalDevHost = (hostname: string): boolean =>
  hostname === 'localhost' ||
  hostname === '[::1]' ||
  /^(127|10)\.\d+\.\d+\.\d+$/.test(hostname) ||
  /^192\.168\.\d+\.\d+$/.test(hostname) ||
  /^172\.(1[6-9]|2\d|3[01])\.\d+\.\d+$/.test(hostname)

const DEV_HOST = /(^|\.)dev\.t-soft\.io$/
// Hosts in the dev zone that run on prod, such as Winners GW's *.guinea.prod.dev.t-soft.io.
const PROD_IN_DEV_ZONE = /(^|\.)prod\.dev\.t-soft\.io$/

// One image serves dev and prod, so the environment comes from the host, not the build.
// Local hosts are dev: the dev proxy points them at a dev load balancer.
export const platformEnvironment = (hostname: string): PlatformEnvironment => {
  if (PROD_IN_DEV_ZONE.test(hostname)) return 'prod'
  return DEV_HOST.test(hostname) || isLocalDevHost(hostname) ? 'dev' : 'prod'
}

export const platformValues = (hostname: string): PlatformValues =>
  PLATFORM_VALUES[platformEnvironment(hostname)]
